/**
 * Détecte une chaîne de classes Font Awesome (v5/v6) pour rendu via <i className="…" />.
 * Ex. : "fa-solid fa-film", "fa-regular fa-user", "fa-brands fa-github"
 * Ancien style : "fa fa-film"
 */
export function isFontAwesomeClassString(icon?: string | null): boolean {
  if (!icon || !String(icon).trim()) {
    return false;
  }
  const s = String(icon).trim();
  // Font Awesome 6
  if (/\bfa-(solid|regular|brands)\b/.test(s)) {
    return true;
  }
  // Font Awesome 4/5 : "fa fa-…"
  if (/^fa\s+fa-/i.test(s) || /\bfa\s+fa-[a-z0-9-]+\b/i.test(s)) {
    return true;
  }
  return false;
}
